import PropTypes from 'prop-types';
import React from 'react';
import './Page.sass';

const Page = ({ padding, children, className, style }) => {
	const pagePadding = padding ? 'p-12' : ''
	return <section className={['absolute w-full h-full top-0 left-0 overflow-hidden', pagePadding, className].join(' ').trim()} style={style}>
		{children}
	</section>
}

Page.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	padding: PropTypes.bool,
	style: PropTypes.object,
}

Page.defaultProps = {
	children: undefined,
	className: undefined,
	padding: undefined,
	style: undefined,
}

export default Page;
